import React, {Component} from "react";
import {connect} from "react-redux";
import Webcam from "react-webcam";
import {changeView} from "../actions/assessment";
import {Translate} from "react-redux-i18n";
import {SaveUserStateToServerHelper} from "./Helper";

export class IdCaptureInstructions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            can_access_webcam: null,
        }
    }

    handleContinue = () => {
        this.props.continue("id_capture");
    };

    onUserMediaError = () => {
        alert("Can't access webcam, please contact administrator.");
        this.setState({can_access_webcam: false});
    }

    onUserMedia = () => {
        this.setState({can_access_webcam: true});
    }

    componentDidMount() {
        SaveUserStateToServerHelper(this.props.assessment);
    }
    render() {
        return (
            <div className="main container-fluid h-100">
                <div className="row h-100 justify-content-center align-items-center">
                    <div className="col-12">
                        <div className="container">
                            <div className="row  justify-content-center ">
                                <div className="col-md-10">
                                    <div className="test-info ">
                                        <h3 className="mt-4 mb-3 text-center">
                                            <Translate value="id_capture_header"/>
                                        </h3>
                                        <p className="mb-4">
                                            <Translate value="id_capture_instructions"/>
                                        </p>

                                        <Webcam className="col-12 mb-4"
                                                style={{
                                                    backgroundColor: "black",
                                                    border: "solid 2px yellow",
                                                    borderRadius: "8px"
                                                }}
                                                onUserMediaError={this.onUserMediaError}
                                                onUserMedia={this.onUserMedia}
                                        />


                                        <div className="button-wrap">
                                            <button
                                                className={"btn btn-main btn-global btn-block " + (!this.state.can_access_webcam && "disabled")}
                                                onClick={this.handleContinue}>
                                                <Translate value="cont"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = state => ({
    ...state,
});

const mapDispatchToProps = dispatch => ({
    continue: (view) => dispatch(changeView(view)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IdCaptureInstructions);
